import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  accessingCurrentSpaceAsStaff,
  commonRoomPostsExcludingRecentImportantSelector,
  importantPostsCountSelector,
  importantPostsSelector,
  participantCount,
  postsSelector,
  recentImportantPostsSelector,
  participants,
} from '@core/selectors/classroom';

import { getCurrentSpaceId } from '@core/selectors/space';
import { currentUser } from '@core/selectors/user';
import { fetchClassRoomParticipants } from '@core/actions/classRoom/participants';
import CommonRoomResponsive from './CommonRoomResponsive';

export const responsiveCommonRoomPostsSelector = createSelector(
  [
    recentImportantPostsSelector,
    commonRoomPostsExcludingRecentImportantSelector,
  ],
  (recentPosts, posts) => [...recentPosts, ...posts].filter(Boolean)
);

export const responsiveUnpinnedPostsSelector = createSelector(
  [postsSelector, importantPostsSelector],
  (posts, pinnedPosts) => {
    const pinnedPostIds = new Set(
      pinnedPosts.filter(Boolean).map((post) => post.objectId)
    );

    return posts
      .filter(Boolean)
      .filter((post) => !pinnedPostIds.has(post.objectId));
  }
);

const mapStateToProps = (state) => {
  const spaceId = getCurrentSpaceId(state);
  const user = currentUser(state);

  return {
    isFetchingParticipants: state.classRoom.isFetchingParticipants,
    participantTotal: participantCount(state),
    participants: participants(state, spaceId),
    readOnly: accessingCurrentSpaceAsStaff(state),
    spaceId,
    // Keep the existing feed collection for desktop. The separate collections
    // below drive the mobile Post/Pinned tabs only.
    posts: commonRoomPostsExcludingRecentImportantSelector(state),
    mobilePosts: responsiveUnpinnedPostsSelector(state),
    pinnedPosts: importantPostsSelector(state).filter(Boolean),
    recentPinnedPosts: recentImportantPostsSelector(state).filter(Boolean),
    pinnedCount: importantPostsCountSelector(state),
    author: user
      ? {
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          avatarUrl: user.avatar,
        }
      : undefined,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchParticipantsPreview: () =>
    dispatch(
      fetchClassRoomParticipants({ reset: true, skip: 0, sort: undefined })
    ),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommonRoomResponsive);
